import { Teaser as t } from '@xprog/prensa/types'

export const TeaserRadio: t.TeaserProps = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  customLinkProps:{ bypass: 'true'},
  css: {
    backgroundColor: 'none',
    cursor: 'pointer',
    p: '$0',
    m: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto',
    },
    '.TeaserImage': {
      mb: '$3',
      mx: '$4',
      width: '100px',
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%',
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 25%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '100px',
      width: '100px',
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'center', 'middle'],
    },
    '.TeaserSubtitleText': {
      color: '#c6c6c6',
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: 400,
      mx: '$2',
      mb: '$2',
      textAlign: 'center',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    },
    '.TeaserTitle': {
      align: ['row', 'center', 'middle'],
    },
    '.TeaserTitleText': {
      color: '#7c7c7c',
      fontSize: '18px',
      letterSpacing: '0.4px',
      lineHeight: '25px',
      fontWeight: 500,
      mx: '$2',
      mb: '$1',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    }
  },
}
